import FlashLightning from '@/images/FlashLightning.svg';
import { ttsVoiceTierFilter } from '@/state/presenters';
import { TIER } from '@d-id/tts';
import { SelectChangeEvent } from '@mui/material/Select';
import { useRecoilState } from 'recoil';
import { FilterChipSelect, FilterOption } from './FilterChipSelect';

const defaultOption = { value: 'all', label: 'All', chipLabel: 'Tier', icon: FlashLightning, skipListIcon: true };

const genderOptions: FilterOption[] = [
    defaultOption,
    { value: TIER.STANDARD, label: 'Standard' },
    { value: TIER.PREMIUM, label: 'Premium' },
];
export const TierChipSelect = () => {
    const [ttsVoiceTierFilterValue, setTtsVoiceTierFilter] = useRecoilState(ttsVoiceTierFilter);

    const handleChange = (e: SelectChangeEvent<string>) => {
        const value = (genderOptions.find(o => o.value === e.target.value)?.value as TIER) || null;

        setTtsVoiceTierFilter(value);
    };

    const option = genderOptions.find(option => option.value === ttsVoiceTierFilterValue) || defaultOption;

    return (
        <FilterChipSelect
            data-testid="voice-tier-filter"
            id="tier-filter"
            value={option}
            options={genderOptions}
            onChange={handleChange}
            variant={'outlined'}
        />
    );
};
